import { render, staticRenderFns } from "./ThgInviteFriendsCard.vue?vue&type=template&id=8f2ff9b0&scoped=true"
import script from "./ThgInviteFriendsCard.vue?vue&type=script&lang=ts"
export * from "./ThgInviteFriendsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2ff9b0",
  null
  
)

export default component.exports